export const SkeletonItem = ({ count = 1 }) => (
  <>
    {[...Array(count)].map((_, i) => (
      <div className="bg-white my-1 p-4" key={i}>
        <div className="animate-pulse flex space-x-4 items-center">
          <div className="rounded-full bg-gray-200 h-12 w-12"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
      </div>
    ))}
  </>
);
